import { rankingItems } from '@/mocks/home';

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-white',
  2: 'bg-accent-500 text-white',
  3: 'bg-secondary-500 text-white',
};

const trendConfig: Record<string, { icon: string; cls: string }> = {
  hot: { icon: 'ri-fire-line', cls: 'text-primary-500' },
  up: { icon: 'ri-arrow-up-line', cls: 'text-accent-500' },
  new: { icon: 'ri-sparkling-line', cls: 'text-secondary-500' },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热播榜单
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              全网最受欢迎的海角视频实时热度排行
            </p>
          </div>
          <div className="rounded-2xl bg-background-50 border border-background-200/60 overflow-hidden">
            {rankingItems.map((item, idx) => {
              const rankCls = rankColors[item.rank] || 'bg-background-200 text-foreground-600';
              const trend = trendConfig[item.trend];
              return (
                <a
                  key={item.id}
                  href="#media"
                  className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors ${
                    idx < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
                  }`}
                >
                  <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${rankCls}`}>
                    {item.rank}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-900 truncate">
                      {item.title}
                    </h3>
                    <div className="text-xs text-foreground-400 mt-0.5">{item.author}</div>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-xs text-foreground-500">{item.heat}</span>
                    <i className={`${trend.icon} text-sm ${trend.cls}`}></i>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}